import type { GolfTournament } from '@img-arena/consoles-api-dde'
import { ddeApi } from '@/service/ddeApi'

import { createBaseTableStore } from '../table'
import { FetchApiArgs, FetchApiResponse } from '../table/table.types'

export const fetchApi = async (
  args: FetchApiArgs<{ tournamentId: number }>
): Promise<FetchApiResponse<GolfTournament>> => {
  const {
    additionalParams: { tournamentId }
  } = args

  const { data } = await ddeApi.endpoints.golf.tournaments.getTournament(tournamentId)

  return {
    content: [data],
    totalElements: data ? 1 : 0
  }
}

export const useGolfPricingTournamentStore = createBaseTableStore({
  storeName: 'DDE Golf Pricing - Tournament',
  fetchApi
})
